import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import type { HomeMd, UserMd } from '@property.com.au/ui-kit';
import { Strong, spacingHelper, Text } from '@property.com.au/ui-kit';
import type { TooltipProps } from 'recharts';
import { GraphTooltip } from '../../GraphTooltip/GraphTooltip';
import type { GraphHoverDescription } from '../types';
import { SupplyDemandChartToolTipIcon } from './SupplyDemandChartToolTipIcon';

// eslint-disable-next-line @typescript-eslint/no-duplicate-type-constituents
export type Icons = typeof HomeMd | typeof UserMd;

const ValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacingHelper('twoExtraSmall')};
`;

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const DescriptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacingHelper('extraSmall')};
  padding: ${spacingHelper('extraSmall large small large')};
`;

interface GraphTooltipDescriptionProps {
  description: GraphHoverDescription;
}

const GraphTooltipDescription: FunctionComponent<GraphTooltipDescriptionProps> = ({
  description: { icon, subtitle, value },
}) => {
  return (
    <DescriptionWrapper>
      <Text variant="body02">{subtitle}</Text>
      <ValueWrapper>
        <SupplyDemandChartToolTipIcon iconName={icon} />
        <Text variant="body02">
          <Strong>{value}</Strong>
        </Text>
      </ValueWrapper>
    </DescriptionWrapper>
  );
};

interface GraphTooltipProps {
  label: string;
  description: GraphHoverDescription[];
}

export const SupplyDemandAndPerformanceBrickTooltip: FunctionComponent<GraphTooltipProps> = ({
  label,
  description: descriptions,
}) => (
  <GraphTooltip label={label}>
    <DescriptionsWrapper>
      {descriptions.map((description) => (
        <GraphTooltipDescription key={description.value} description={description} />
      ))}
    </DescriptionsWrapper>
  </GraphTooltip>
);

export const SupplyDemandAndPerformanceBrickGraphTooltip: FunctionComponent<
  TooltipProps<number, string>
> = ({ active, payload }) => {
  if (active && payload && payload.length) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const { label, description } = payload[0]?.payload.hover as GraphTooltipProps;

    return <SupplyDemandAndPerformanceBrickTooltip label={label} description={description} />;
  }
  return null;
};
